export type SpaceRoleFields = 'basic' | 'all'

// eslint-disable-next-line unused-imports/no-unused-vars
export function spaceRoleGQLFields(fields: SpaceRoleFields) {
  return `
    id
    name
    type
    description
  `
}
